export const SUBMIT_LOGIN = "SUBMIT_LOGIN";
export const SECURE_CODE = "SECURE_CODE";
export const SELECT_COMMUNICATION_METHOD = "SELECT_COMMUNICATION_METHOD";
export const GET_USER_SERVICES = "GET_USER_SERVICES";
export const GET_ACTIVE_ACCOUNT = "GET_ACTIVE_ACCOUNT";
export const GET_FAMILY_MEMBERS = "GET_FAMILY_MEMBERS";
export const SET_HAS_IDF_FAMILY_SERVICE = "SET_HAS_IDF_FAMILY_SERVICE";
export const SUBMIT_COMMUNICATION_METHOD = "SUBMIT_COMMUNICATION_METHOD";
export const TERMS_AND_CONDITION_REACCEPTANCE = "TERMS_AND_CONDITION_REACCEPTANCE";
export const SET_CHILD_SUBCUSTOMER_ID = "SET_CHILD_SUBCUSTOMER_ID";
export const SET_BUSINESS_NAME = "SET_BUSINESS_NAME";
export const SET_USER_FIRSTNAME_AND_LASTNAME = "SET_USER_FIRSTNAME_AND_LASTNAME";
export const SET_FAMILY_MEMBER_LOADER = "SET_FAMILY_MEMBER_LOADER";
export const SET_CHILD_DOB = "SET_CHILD_DOB";
export const SET_IS_TU_USER = "SET_IS_TU_USER";
export const SET_PREFERENCED_LANGUAGE = "SET_PREFERENCED_LANGUAGE";
export const SET_LANGUAGE_CHANGE = "SET_LANGUAGE_CHANGE";
export const SET_USER_PHONE = "SET_USER_PHONE";
export const SET_HAS_CCAM = "SET_HAS_CCAM";
export const SET_SUCCESSFUL_ENROLLED_CHILD_LIST = "SET_SUCCESSFUL_ENROLLED_CHILD_LIST";
export const SET_FAILED_ENROLLED_CHILD_LIST = "SET_FAILED_ENROLLED_CHILD_LIST";
export const SET_MONITORED_CHILD_COUNT = "SET_MONITORED_CHILD_COUNT";
export const RECEIVE_CATALOG_PRODUCTS = "RECEIVE_CATALOG_PRODUCTS";
export const GET_AGE_LIMIT = "GET_AGE_LIMIT";
export const GET_ACTIVE_PACKAGE_ENROLLMENT = "GET_ACTIVE_PACKAGE_ENROLLMENT";

export interface ILoggedInUserState {
    userInfo?: UserInfo;
    secureCode?: any;
    selectedMethod?: string;
    childSubcustomerIdToCompleteAccount?: string;
    userServiceDetails?: UserServiceDetails;
    familyMembers?: IUserFamilyAccountInfo[];
    hasFamilyService?: boolean;
    activeAccount: IUserFamilyAccountInfo;
    communicationMethodList?: communicationMethod[];
    termsAndConditionsReacceptance?: ITermsAndConditionReAcceptance;
    businessName?: string;
    isLoadingFamilyMember: boolean;
    childDOBToCompleteAccount?: string;
    isLoadedActiveUserServices: boolean;
    catalogProducts?: ICatalogProducts[];
    oneTimeProducts?: ICatalogProducts[];
    hasPurchaseCreditReport?: boolean;
    ageLimit?: IAgeLimitInfo;
    activePackageInfo?: IActivePackageInfo;
}

export interface ITermsAndConditionReAcceptance {
    isTermsAndConditionUpdated?: boolean;
    termsAndConditions?: string;
}
export interface IChildList {
    customerId?: string;
    message?: string;
}

export interface IFailedChildList {
    id?: number;
}

export interface UserInfo {
    id?: number;
    EmailAddress?: string;
    idfUserId?: number;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    userType?: string;
    workCaseID?: string;
    partnerID?: string;
    portalName?: string;
    subscriptionKey?: string;
    isEZSPartner?: boolean;
    nukeUserId?: string;
    personalSMS?: string;
    forcePasswordUpdate?: boolean;
    isPasswordExpired?: boolean;
    errorMessage?: string;
    isTUUser?: boolean;
    primaryPhone?: string;
    loginUserName?: string;
    preferencedLanguage?: string;
    hasLanguageChanged?: boolean;
    phoneNumber?: string;
    isCCMTUser?: boolean;
    isCsMigratedUser?: boolean;
    hasCCAM?: boolean;
    childrenList?: any;
    failedChildrenList?: any;
    numChildrenMonitored?: number;
}

export interface UserService {
    serviceCode?: string;
    displayName?: string;
    active?: boolean;
    availableForPurchase?: boolean;
    serviceFeatures?: ServiceFeature[];
    serviceCategory?: string;
    lastScanDate?: string;
    lastUpdateDate?: string;
    displayText?: IDisplayText;
    serviceName?: string;
    productDescription?: string;
    isScore?: boolean;
    isReport?: boolean;
    isReportAndScore?: boolean;
}

export interface IDisplayText {
    text?: string;
    url?: string;
}

export interface IUserFamilyAccountInfo {
    accountType?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    recurringCost?: string;
    registrationStatus?: boolean;
    accountAdditionalId?: string;
    subcustomerId?: string;
    dateOfBirth?: string;
    cancelDate?: string;
    userId?: string;
    setUpCompleteDate?: string;
    price?: number;
    showCreditActivity?: boolean;
}

export interface ServiceFeature {
    key?: string;
    value?: string;
}

export interface IUserFirstNameLastName {
    firstName?: string;
    lastName?: string;
}

export interface communicationMethod {
    methodType?: string;
    recepientAddress?: string;
}

export interface UserServiceDetails {
    hasVpn?: boolean;
    isBusinessUser?: boolean;
    userServices?: UserService[];
    //---- business user--------//`
    businessProfileStatus?: any;
    isBCMMonitored?: any;
    lmsRedirectUrl?: string;
    isNYStateUser?: boolean;
}

export interface IAgeLimitInfo {
    maxAgeLimit: string;
    minAgeLimit: string;
}

export interface IActivePackageInfo {
    packageCode: string;
    packageDisplayName: string;
    packageType: string;
}
export interface SubmitLoginAction {
    type: "SUBMIT_LOGIN";
    userInfo: UserInfo;
}
export interface LogoutAction {
    type: "USER_LOGGED_OUT";
}
export interface SecureCode {
    type: "SECURE_CODE";
    secureCode: any;
}
export interface SelectedMethod {
    type: "SELECT_COMMUNICATION_METHOD";
    selectedMethod: string;
}
export interface GetUserServiceAction {
    type: "GET_USER_SERVICES";
    userServiceDetails: UserServiceDetails;
}
export interface GetActiveAccountAction {
    type: "GET_ACTIVE_ACCOUNT";
    activeAccount: IUserFamilyAccountInfo;
}
export interface GetFamilyMembersAction {
    type: "GET_FAMILY_MEMBERS";
    familyMembers: IUserFamilyAccountInfo[];
}
export interface SubmitCommunicationMethodAction {
    type: "SUBMIT_COMMUNICATION_METHOD";
    communicationMethodList: communicationMethod[];
}
export interface TermsAndCondtitonReacceptanceAction {
    type: "TERMS_AND_CONDITION_REACCEPTANCE";
    termsAndConditionsReacceptance: ITermsAndConditionReAcceptance;
}
export interface SetHasIdfFamilyServiceAction {
    type: "SET_HAS_IDF_FAMILY_SERVICE";
    hasFamilyService: boolean;
}
export interface SetChildSubCustomerIDAction {
    type: "SET_CHILD_SUBCUSTOMER_ID";
    childSubcustomerIdToCompleteAccount: string;
}
export interface ReloadUserPermissionAction {
    type: "RELOAD_USER_PERMISSION";
}
export interface BusinessNameAction {
    type: "SET_BUSINESS_NAME";
    businessName?: string;
}
export interface SetUserFirstNameLastName {
    type: "SET_USER_FIRSTNAME_AND_LASTNAME";
    userInformation: IUserFirstNameLastName;
}
export interface SetFamilyMemberLoaderAction {
    type: "SET_FAMILY_MEMBER_LOADER";
    isLoadingFamilyMember: boolean;
}
export interface SetChildDOBAction {
    type: "SET_CHILD_DOB";
    childDOBToCompleteAccount: string;
}
export interface SetIsTuUserAction {
    type: "SET_IS_TU_USER";
    isTuUser?: boolean;
}
export interface SetPreferencedLanguageAction {
    type: "SET_PREFERENCED_LANGUAGE";
    preferencedLanguage?: string;
}

export interface SetLanguageChangeAction {
    type: "SET_LANGUAGE_CHANGE";
    hasLanguageChanged?: boolean;
}

export interface SetUserPhoneNumber {
    type: "SET_USER_PHONE";
    phoneNumber?: string;
}
export interface SetHasCCAMAction {
    type: "SET_HAS_CCAM";
    hasCCAM?: boolean;
}
export interface SetSuccessfulEnrolledChildList {
    type: "SET_SUCCESSFUL_ENROLLED_CHILD_LIST";
    childrenList?: IChildList[];
}
export interface SetFailedEnrolledChildList {
    type: "SET_FAILED_ENROLLED_CHILD_LIST";
    failedChildrenList?: IFailedChildList[];
}
export interface SetMonitoredChildCount {
    type: "SET_MONITORED_CHILD_COUNT";
    numChildrenMonitored?: number;
}

export interface IReceiveCatalogProducts {
    type: "RECEIVE_CATALOG_PRODUCTS";
    catalogProducts: ICatalogProducts[];
    oneTimeProducts: ICatalogProducts[];
    hasPurchaseCreditReport: boolean;
}

export interface ICatalogProducts {
    Bullets: string;
    Children: string;
    FullHTML: string;
    IsHidden: string;
    Price: number;
    ServiceCode: string;
    ServiceName: string;
    ShortHTML: string;
}
export interface GetHouseholdAgeLimitAction {
    type: "GET_AGE_LIMIT";
    ageLimit: IAgeLimitInfo;
}

export interface GetActivePackage {
    activePackage: any;
    type: "GET_ACTIVE_PACKAGE_ENROLLMENT";
    activePackageInfo: IActivePackageInfo;
}


export type KnownAction =
    | SetUserFirstNameLastName
    | ReloadUserPermissionAction
    | BusinessNameAction
    | SubmitLoginAction
    | LogoutAction
    | SecureCode
    | SelectedMethod
    | GetUserServiceAction
    | GetActiveAccountAction
    | GetFamilyMembersAction
    | TermsAndCondtitonReacceptanceAction
    | SubmitCommunicationMethodAction
    | SetChildSubCustomerIDAction
    | SetHasIdfFamilyServiceAction
    | SetFamilyMemberLoaderAction
    | SetChildDOBAction
    | SetIsTuUserAction
    | SetPreferencedLanguageAction
    | SetUserPhoneNumber
    | SetHasCCAMAction
    | SetSuccessfulEnrolledChildList
    | SetFailedEnrolledChildList
    | SetMonitoredChildCount
    | IReceiveCatalogProducts
    | GetHouseholdAgeLimitAction
    | SetLanguageChangeAction
    | GetActivePackage;
    
